module.exports = __webpack_public_path__ + "media/video2-m.65ad3e70.mp4";